import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", { fill: "#252729" }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("g", null, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M10 4.167c3.171 0 6.342 1.716 9.513 5.15.262.283.292.704.086 1.02l-.062.083-.255.297c-2.983 3.41-6.178 5.116-9.585 5.116-3.506 0-6.605-1.807-9.297-5.42-.217-.293-.218-.688-.012-.979l.068-.084.28-.3C3.824 5.794 6.912 4.167 10 4.167zm0 1.25c-2.619 0-5.312 1.376-8.082 4.208l-.305.317.009.012c2.34 3.027 4.925 4.536 7.804 4.625l.271.004c2.922 0 5.708-1.44 8.386-4.4l.257-.29-.014-.015c-2.77-2.91-5.459-4.369-8.073-4.457L10 5.417zm0 1.25c1.84 0 3.333 1.492 3.333 3.333 0 1.84-1.492 3.333-3.333 3.333-1.84 0-3.333-1.492-3.333-3.333 0-1.84 1.492-3.333 3.333-3.333zm0 1.25c-1.15 0-2.083.932-2.083 2.083 0 1.15.932 2.083 2.083 2.083 1.15 0 2.083-.932 2.083-2.083 0-1.15-.932-2.083-2.083-2.083z",
                    transform: "translate(-866 -394) translate(500 96) translate(40 260) translate(0 28) translate(320 4) translate(6 6)"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }